import React, { Component } from 'react'
import "../../../css/general-style.css"
import "../../../css/dashboard.css"
import LoadingWindow from '../../../components/LoadingWindow';
import { create_Delete_Update_Information, getInformationWithData } from '../../../services/CABE';
import { getIndexElement } from '../../../functions/searchInObject';
import { IncludeProducts } from './Class';
import { confirmCloseAlert } from '../../../functions/alerts';
import { AiOutlineSearch, AiOutlinePlus } from "react-icons/ai";
import { BsBoxSeam } from "react-icons/bs";
import { Menu } from "../../../components/Menu/Menu";
import { pricesFormat } from '../../../functions/pricesFormat';

export default class NewProductsView extends Component {

    constructor(props) {
        super(props)
        this.ModalLoading = React.createRef();
    }
    state = {
        FilterProducts: [],
        Products: [],
        search: '',
        activeLine: 'All',
    }

    clearAll() {
        this.setState({ FilterProducts: [], Products: [], search: '', activeLine: 'All' })
    }

    async getProductsToInclude() {
        this.ModalLoading.current.showState(true);
        let Products = []
        const data = { idcompany: '-1' }
        const actualProducts = await getInformationWithData('/Items/get', data)
        data.idcompany = '3'
        const compareProducts = await getInformationWithData('/Items/get', data)

        if (actualProducts.status.code === 1 && compareProducts.status.code === 1) {
            for (const item of compareProducts.data) {
                const index = getIndexElement(actualProducts.data, 'itemCode', item.itemCode)
                if (index === -1) {
                    var includeProd = new IncludeProducts(item.itemCode, item.ProductLine, item.ProductLineDesc, item.abbreviatedDesc, item.LastTotalUnitCost)
                    Products.push(includeProd)
                }
            }
        }

        this.setState({ FilterProducts: Products, Products: Products, search: '', activeLine: 'All' })
        this.ModalLoading.current.showState(false);
    }

    async importAllNewProducts() {
        const data = { Products: this.state.Products }
        const result = await create_Delete_Update_Information('/Items/sync/Alt', data)
        if (result.status.code === 1) {
            confirmCloseAlert('correct', 'Products included successfully!')
            this.clearAll()
        } else {
            confirmCloseAlert('incorrect', 'Something went wrong. Try again!')
        }
    }

    Contains(parametro, busqueda) {
        if (parametro && busqueda) {
            return parametro.toString().toLowerCase().includes(busqueda.toLocaleLowerCase())
        }
        return false
    }

    applyFilters(search, line, products) {
        let filtered = products || this.state.Products
        if (search) {
            filtered = filtered.filter(d =>
                this.Contains(d.ItemCode, search) ||
                this.Contains(d.ProductLine, search) ||
                this.Contains(d.Description, search)
            )
        }
        if (line && line !== 'All') {
            filtered = filtered.filter(d => d.ProductLine === line)
        }
        return filtered
    }

    handleSearch = (e) => {
        const search = e.target.value
        this.setState({ search, FilterProducts: this.applyFilters(search, this.state.activeLine) })
    }

    handleLineFilter = (line) => {
        this.setState({ activeLine: line, FilterProducts: this.applyFilters(this.state.search, line) })
    }

    getProductLines() {
        const lines = new Set(this.state.Products.map(p => p.ProductLine).filter(Boolean))
        return ['All', ...Array.from(lines).sort()]
    }

    render() {
        const hasData = this.state.Products.length > 0
        const lines = this.getProductLines()
        const visible = this.state.FilterProducts.filter(i => i.Visible !== 0)

        return (
            <div className="dash-page" style={{ paddingTop: '70px' }}>
                {this.props.showMenu && <Menu />}
                <LoadingWindow ref={this.ModalLoading} />

                {/* Hero */}
                <div style={{ background: 'linear-gradient(135deg, #0f172a 0%, #1e3a5f 50%, #2563EB 100%)', padding: '1.25rem 2rem', display: 'flex', alignItems: 'center', gap: '1rem', flexWrap: 'wrap' }}>
                    <div style={{ background: 'rgba(255,255,255,0.12)', borderRadius: '12px', padding: '0.75rem', display: 'flex' }}>
                        <BsBoxSeam style={{ color: 'white', fontSize: '1.75rem' }} />
                    </div>
                    <div style={{ flex: 1 }}>
                        <h1 style={{ color: 'white', fontWeight: 800, fontSize: '1.375rem', margin: 0 }}>Products to Include</h1>
                        <p style={{ color: 'rgba(255,255,255,0.6)', margin: 0, fontSize: '0.8rem' }}>
                            {hasData
                                ? `${visible.length} of ${this.state.Products.length} products · pending inclusion`
                                : 'Products present in Altitude but not yet in the system'}
                        </p>
                    </div>
                    <div style={{ display: 'flex', gap: '0.625rem', alignItems: 'center' }}>
                        {hasData && (
                            <button onClick={() => this.importAllNewProducts()}
                                style={{ background: 'rgba(16,185,129,0.2)', border: '1px solid rgba(16,185,129,0.4)', borderRadius: '8px', color: '#6EE7B7', fontWeight: 700, padding: '0.45rem 1rem', fontSize: '0.875rem', cursor: 'pointer', display: 'inline-flex', alignItems: 'center', gap: '0.4rem' }}>
                                <AiOutlinePlus /> Include All
                            </button>
                        )}
                        <button onClick={() => this.getProductsToInclude()}
                            style={{ background: 'rgba(255,255,255,0.15)', border: '1px solid rgba(255,255,255,0.3)', borderRadius: '8px', color: 'white', fontWeight: 700, padding: '0.45rem 1rem', fontSize: '0.875rem', cursor: 'pointer', display: 'inline-flex', alignItems: 'center', gap: '0.4rem' }}>
                            <AiOutlineSearch /> Search Products
                        </button>
                    </div>
                </div>

                <div style={{ padding: '1.5rem 2rem' }}>
                    {!hasData ? (
                        <div style={{ textAlign: 'center', padding: '4rem 2rem', color: '#94A3B8' }}>
                            <BsBoxSeam style={{ fontSize: '3rem', opacity: 0.2, marginBottom: '1rem' }} />
                            <p style={{ fontSize: '0.9rem', fontWeight: 500 }}>Click <strong>Search Products</strong> to find items pending inclusion.</p>
                        </div>
                    ) : (
                        <div className="card" style={{ borderRadius: '12px', border: '1px solid #E2E8F0', overflow: 'hidden' }}>
                            {/* Header: search + product line pills */}
                            <div style={{ background: 'linear-gradient(135deg, #0f172a 0%, #1e3a8a 100%)', padding: '0.875rem 1.25rem' }}>
                                {/* Search */}
                                <div style={{ position: 'relative', marginBottom: '0.75rem' }}>
                                    <AiOutlineSearch style={{ position: 'absolute', left: '10px', top: '50%', transform: 'translateY(-50%)', color: 'rgba(255,255,255,0.5)', fontSize: '1rem' }} />
                                    <input
                                        value={this.state.search}
                                        onChange={this.handleSearch}
                                        placeholder="Search by item code, description, product line..."
                                        id='searchNewProductSync'
                                        type="text"
                                        style={{ background: 'rgba(255,255,255,0.12)', border: '1px solid rgba(255,255,255,0.2)', borderRadius: '8px', color: 'white', fontSize: '0.8125rem', padding: '0.35rem 0.75rem 0.35rem 2rem', width: '100%', outline: 'none' }}
                                    />
                                </div>
                                {/* Product line filter pills */}
                                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.3rem' }}>
                                    {lines.map(line => {
                                        const isActive = this.state.activeLine === line
                                        const count = line === 'All'
                                            ? this.state.Products.length
                                            : this.state.Products.filter(p => p.ProductLine === line).length
                                        return (
                                            <button key={line} onClick={() => this.handleLineFilter(line)}
                                                style={{ padding: '0.25rem 0.7rem', borderRadius: '6px', border: 'none', cursor: 'pointer', fontWeight: 700, fontSize: '0.78rem', background: isActive ? 'rgba(255,255,255,0.25)' : 'rgba(255,255,255,0.08)', color: isActive ? 'white' : 'rgba(255,255,255,0.6)', display: 'inline-flex', alignItems: 'center', gap: '0.25rem' }}>
                                                {line}
                                                <span style={{ background: isActive ? 'rgba(255,255,255,0.2)' : 'rgba(255,255,255,0.1)', borderRadius: '999px', padding: '0 4px', fontSize: '0.68rem' }}>{count}</span>
                                            </button>
                                        )
                                    })}
                                </div>
                            </div>

                            {/* Products grid — ItemCardNoPrices style */}
                            <div style={{ padding: '1.25rem' }}>
                                {visible.length === 0 ? (
                                    <p style={{ textAlign: 'center', color: '#94A3B8', fontSize: '0.875rem', padding: '2rem 0' }}>No products match the current filter.</p>
                                ) : (
                                    <div className="row g-3">
                                        {visible.map((item, i) => (
                                            <div key={i} className="col-12 col-md-6 col-xl-4">
                                                {/* Product card — same style as ItemCardNoPrices from Inventory Catalogue */}
                                                <div style={{
                                                    background: '#ffffff',
                                                    border: '1px solid #E2E8F0',
                                                    borderRadius: '12px',
                                                    padding: '12px',
                                                    display: 'flex',
                                                    gap: '12px',
                                                    alignItems: 'center',
                                                    transition: 'border-color 0.18s, box-shadow 0.18s',
                                                }}
                                                    onMouseEnter={e => { e.currentTarget.style.borderColor = '#2563EB'; e.currentTarget.style.boxShadow = '0 2px 8px rgba(37,99,235,0.10)'; }}
                                                    onMouseLeave={e => { e.currentTarget.style.borderColor = '#E2E8F0'; e.currentTarget.style.boxShadow = 'none'; }}
                                                >
                                                    {/* Icon placeholder (no image yet for new products) */}
                                                    <div style={{ width: '56px', height: '56px', borderRadius: '10px', background: '#F1F5F9', border: '1px solid #E2E8F0', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                                                        <BsBoxSeam style={{ color: '#CBD5E1', fontSize: '1.5rem' }} />
                                                    </div>

                                                    {/* Info */}
                                                    <div style={{ flex: 1, minWidth: 0 }}>
                                                        {/* Badges */}
                                                        <div style={{ display: 'flex', gap: '5px', flexWrap: 'wrap', marginBottom: '5px' }}>
                                                            <span style={{ background: 'rgba(37,99,235,0.08)', color: '#1e40af', border: '1px solid #BFDBFE', borderRadius: '6px', padding: '2px 8px', fontSize: '0.72rem', fontWeight: 700 }}>
                                                                {item.ItemCode}
                                                            </span>
                                                            {item.ProductLine && (
                                                                <span style={{ background: 'rgba(139,92,246,0.08)', color: '#5b21b6', border: '1px solid #DDD6FE', borderRadius: '6px', padding: '2px 8px', fontSize: '0.72rem', fontWeight: 700 }}>
                                                                    {item.ProductLine}
                                                                </span>
                                                            )}
                                                        </div>
                                                        {/* Description */}
                                                        <p style={{ margin: '0 0 4px', fontSize: '0.8375rem', color: '#0F172A', fontWeight: 500, lineHeight: 1.4, overflow: 'hidden', display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical' }}>
                                                            {item.Description}
                                                        </p>
                                                        {/* Unit cost */}
                                                        {item.UnitCost > 0 && (
                                                            <span style={{ fontSize: '0.75rem', color: '#059669', fontWeight: 700 }}>
                                                                Cost: ${pricesFormat(item.UnitCost)}
                                                            </span>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </div>

                            {/* Footer */}
                            <div style={{ padding: '0.75rem 1.25rem', borderTop: '1px solid #E2E8F0', background: '#F8FAFC', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                <span style={{ fontSize: '0.78rem', color: '#64748B' }}>
                                    {visible.length} products shown · {this.state.Products.length} total pending
                                </span>
                                <button onClick={() => this.importAllNewProducts()}
                                    style={{ background: 'linear-gradient(135deg, #065F46, #059669)', color: 'white', border: 'none', borderRadius: '8px', padding: '0.4rem 1rem', fontWeight: 700, fontSize: '0.8125rem', cursor: 'pointer', display: 'inline-flex', alignItems: 'center', gap: '0.4rem' }}>
                                    <AiOutlinePlus /> Include All Products
                                </button>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        )
    }
}
